export const MANAGE_FIRM_EXPAND_JURISDICTIONS_BUTTON_CLASS =
  "inline-flex h-7 w-7 mx-auto shrink-0 items-center justify-center rounded-lg bg-accent-Default-dark text-white transition-colors hover:bg-secondary";
